import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';

import { useRouteServerErrorRegistration } from '@/config/routeServerError';
import { LOGIN } from '@/constants/routes';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { useUrlState } from '@/hooks/useUrlState';
import Error from '@/pages/Error';
import { useAppDispatch } from '@/store/hooks';
import { restoreSessionIfNeeded } from '@/store/sessionBootstrap';
import { getAccessToken } from '@/utils/localStorage';

const GuestRoute = () => {
  const dispatch = useAppDispatch();
  const [error, setError] = useState(false);
  const { isAuth, user } = useCurrentUser();
  const { history } = useUrlState();
  const token = getAccessToken();

  useRouteServerErrorRegistration(setError);

  useEffect(() => {
    restoreSessionIfNeeded(dispatch);
    if (!token && !isAuth) {
      history.push(LOGIN);
    }
  }, [dispatch, history, isAuth, token, user]);

  if (error) {
    return <Error />;
  }
  return user ? <Outlet /> : null;
};

export default GuestRoute;
